module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAAVBJREFUKJGNks9KAmEUR8/MRs2JyVo4U22SjIqCaOFjuBCH/pAPkbZs46JWQa+RSAQ9RkG4ELWEJJmcsYUkGY2r28KwUZE6cFf3dy7c77sKY0iaE/SohddbByCo1ei0i8oNF/6cMhRSLDOj3XFwNoe5FmJlZ9BolMB5+uLqtEP3I6Hc0sIvSXbbFacuU3mtiRxvtSSF+Sseaa0JKc2g/NhVkYxuA6iS5oTD8wjG6vi6kyytw15+XlLkVPSohREP/m39YMZDRAxLpf+5MXyI/xDbhX5vU/2/MYpKIFylUZrsFGVQ4zw/QECrqHTaRZy6NxGwlEGN4zx6vLsFACQza8tr7e/vaJZFMvrLcIgkWZTsliN2dfoBNMsi2W1XkkRh9ORMwvo9+/kFjHiQ2O7vTs6jRyH/RrebUG5pj4i+ATkihkW/twlAQKvw7haUay79uW/fj+2RMTROUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warn.png
// module id = 1068
// module chunks = 1